export const cabecalhos = [
  {
    text: 'Id Produto',
    value: 'idproduto'
  },
  {
    text: 'Descrição Produto',
    value: 'descricao_produto'
  },
  {
    text: 'Fornecedor',
    value: 'descricao_fornecedor'
  },
  {
    text: 'Fator Conversão',
    value: 'fator_conversao'
  },
  {
    text: 'Projeção de vendas',
    value: 'consumo_medio_mensal',
    is_number: true,
    indicador_comparacao: {
      callbackMelhor: Math.max,
      callbackPior: Math.min
    }
  },
  {
    text: 'Média de vendas trimestral',
    value: 'media_venda_ult_trimestre',
    is_number: true,
    indicador_comparacao: {
      callbackMelhor: Math.max,
      callbackPior: Math.min
    }
  },
  {
    text: 'Média de vendas semestral',
    value: 'media_venda_ult_semestre',
    is_number: true,
    indicador_comparacao: {
      callbackMelhor: Math.max,
      callbackPior: Math.min
    }
  },
  {
    text: 'Média de vendas anual',
    value: 'media_venda_ult_ano',
    is_number: true,
    indicador_comparacao: {
      callbackMelhor: Math.max,
      callbackPior: Math.min
    }
  },
  {
    text: 'Total de vendas trimestral',
    value: 'total_vendido_ult_trimestre',
    is_money: true,
    indicador_comparacao: {
      callbackMelhor: Math.max,
      callbackPior: Math.min
    }
  },
  {
    text: 'Total de vendas semestral',
    value: 'total_vendido_ult_semestre',
    is_money: true,
    indicador_comparacao: {
      callbackMelhor: Math.max,
      callbackPior: Math.min
    }
  },
  {
    text: 'Total de vendas anual',
    value: 'total_vendido_ult_ano',
    is_money: true,
    indicador_comparacao: {
      callbackMelhor: Math.max,
      callbackPior: Math.min
    }
  },
  {
    text: 'Estoque Convertido',
    value: 'estoque', is_number: true,
    indicador_comparacao: {
      callbackMelhor: Math.max,
      callbackPior: Math.min
    }
  },
  {
    text: 'Estoque Und. Mínima',
    value: 'estoque_und',
  },
  {
    text: 'Estoque Trânsito',
    value: 'estoque_transito', is_number: true,
    indicador_comparacao: {
      callbackMelhor: Math.max,
      callbackPior: Math.min
    }
  },
  {
    text: 'Estoque Faturado',
    value: 'estoque_faturado', is_number: true,
    indicador_comparacao: {
      callbackMelhor: Math.max,
      callbackPior: Math.min
    }
  },
  {
    text: 'Preço de Custo',
    value: 'custo_unitario',
    is_money: true,
    indicador_comparacao: {
      callbackMelhor: Math.min,
      callbackPior: Math.max
    }
  },
  {
    text: 'Preço de vendas',
    value: 'valor_unitario',
    is_money: true,
    indicador_comparacao: {
      callbackMelhor: Math.max,
      callbackPior: Math.min
    }
  },
  {
    text: 'Margem',
    value: 'margem',
    is_money: true,
    indicador_comparacao: {
      callbackMelhor: Math.max,
      callbackPior: Math.min
    }
  },
  {
    text: 'Margem (%)',
    value: 'margem_percentual',
    is_percentage: true,
    indicador_comparacao: {
      callbackMelhor: Math.max,
      callbackPior: Math.min
    }
  },
  {
    text: 'Estoque (R$ custo)',
    value: 'estoque_preco_custo',
    is_money: true,
    indicador_comparacao: {
      callbackMelhor: Math.max,
      callbackPior: Math.min
    }
  },
  {
    text: 'Ações',
    value: 'acoes',
  },
];
